import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonTypeUser from "../../button/ButtonTypeUser";
import { ReactComponent as USER } from "../../../assets/IconsColurs/IconsGeneral/user.svg";
import { ReactComponent as BUSINNES } from "../../../assets/IconsColurs/IconsGeneral/business.svg";
import { useNavigate } from "react-router-dom";

const TypeUser = ({ onPress }) => {
  const navigate = useNavigate();

  const { language } = useContext(UtilContext); // Usa el contexto de Auth
  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-full md:w-3/4 flex justify-evenly flex-col"
    >
      <div className="flex flex-col gap-2">
        <p className="text-2xl md:text-3xl mb-4 md:mb-8 mt-6" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].type_user.title}
        </p>
        <div className="flex flex-col gap-4 md:gap-2">
          <div className="flex flex-col md:flex-row w-full gap-2">
            <ButtonTypeUser
              onClick={() => onPress(1)}
              title={GLOBAL_LANGUAGE[language].type_user.button_user}
              Icon={USER}
            />
            <ButtonTypeUser
              onClick={() => onPress(2)}
              title={GLOBAL_LANGUAGE[language].type_user.button_businnes}
              Icon={BUSINNES}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-between mt-8 md:mt-20">
        <div className="flex justify-center">
          <p onClick={() => navigate("/login")} className="text-sm cursor-pointer inline-block  underline">
            <a>{GLOBAL_LANGUAGE[language].type_user.label_acount}</a>
          </p>
        </div>
        <div className="flex justify-center">
          <p className="text-sm cursor-pointer inline-block  underline">
            <a href="https://www.colurs.io/terminos/" target="_blank">
              {GLOBAL_LANGUAGE[language].type_user.terminos_condiciones}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TypeUser;
